import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './global-warming-page.component.html',
  styleUrls: ['./global-warming-page.component.scss']
})
export class GlobalWarmingPageComponent extends MaterialPage {

  constructor(
    breakpointObserver: BreakpointObserver,
    titleService: Title,
    meta: Meta,
    router: Router,
    sidenavService: SidenavService
  ) {
    super(
      breakpointObserver, 
      titleService, 
      meta, 
      sidenavService,
      router,
      $localize `:page title:About us`, 
      $localize `:page description:Listx is on a mission to make it effortless for individuals to participate in the circular economy. Give unused things a new life and help save the planet.`, 
      true);
  }
}
